let item = [
  //baby,birth
    {
      itemId : '20240304-06-A1',
      itemNm   : '곰돌이슈즈',
      category : '06',
      owner  : 'user01',
      buyHoper : ['user02','user03'],
      liker    : ['user02'],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_1.jpg',
      itemDesc : '4세 아가용 슈즈입니다. 귀여운 곰돌이 스티치가 포인트 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A2',
      itemNm   : '고양이슈즈',
      category : '06',
      owner  : 'user01',
      buyHoper : ['user03'],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_2.jpg',
      itemDesc : '4세 아가용 슈즈입니다. 귀여운 고야이 스티치가 포인트 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A3',
      itemNm   : '아디다스운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : ['user02','user03'],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_3.jpg',
      itemDesc : '4세 아가용 아디다스 정품 운동화입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A4',
      itemNm   : '메쉬운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : ['admin'],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_4.jpg',
      itemDesc : '여름용 메쉬소재 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A5',
      itemNm   : '두줄운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_5.jpg',
      itemDesc : '.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A6',
      itemNm   : '아기운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_6.jpg',
      itemDesc : '색감 예쁜 가죽소재 귀여운 운동화',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A7',
      itemNm   : '나이키여름슈즈',
      category : '06',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_7.jpg',
      itemDesc : '나이키 여름용 메쉬 샌들',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A8',
      itemNm   : '삐약이운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_8.jpg',
      itemDesc : '.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240304-06-A9',
      itemNm   : '뉴발운동화',
      category : '06',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/baby/shoe_9.jpg',
      itemDesc : '뉴발란스 귀여운 운동화',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
//bag,clothes
    {
      itemId : '20240311-01-A1',
      itemNm   : '서류가방',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/bag_1.jpg',
      itemDesc : '서류가방입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A2',
      itemNm   : '서류가방',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/bag_2.jpg',
      itemDesc : '서류가방입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A3',
      itemNm   : '서류가방',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/bag_3.jpg',
      itemDesc : '서류가방입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A4',
      itemNm   : '서류가방',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/bag_4.jpg',
      itemDesc : '서류가방입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A5',
      itemNm   : '서류가방',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/bag_5.jpg',
      itemDesc : '서류가방입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A6',
      itemNm   : '버버리원피스',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/cloth_1.jpg',
      itemDesc : '체크무늬 버버리 원피스입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A7',
      itemNm   : '버버리원피스',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/cloth_2.jpg',
      itemDesc : '체크무늬 버버리 원피스입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A8',
      itemNm   : '버버리원피스',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/cloth_3.jpg',
      itemDesc : '체크무늬 버버리 원피스입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A9',
      itemNm   : '버버리원피스',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/cloth_4.jpg',
      itemDesc : '체크무늬 버버리 원피스입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-01-A10',
      itemNm   : '버버리원피스',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/clothes/cloth_5.jpg',
      itemDesc : '체크무늬 버버리 원피스입니다',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
  //digitals
    {
      itemId : '20240311-02-A1',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_1.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-02-A2',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_2.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-02-A3',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_3.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-02-A4',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_4.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-02-A5',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_5.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240311-02-A6',
      itemNm   : '솜사탕키보드',
      category : '01',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/digitals/digi_6.jpg',
      itemDesc : '파스텔 톤 컬러감의 텐키리스 키보드',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
  //green
    {
      itemId : '20240312-05-A1',
      itemNm   : '몬스테라 화분',
      category : '05',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/green/green_1.jpg',
      itemDesc : '키 130cm 건강한 식물입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-05-A2',
      itemNm   : '몬스테라 화분',
      category : '05',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/green/green_2.jpg',
      itemDesc : '키 130cm 건강한 식물입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-05-A3',
      itemNm   : '몬스테라 화분',
      category : '05',
      owner  : 'user01',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/green/green_3.jpg',
      itemDesc : '키 130cm 건강한 식물입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
  //hobby
    {
      itemId : '20240312-08-A1',
      itemNm   : '코바느질 DIY 세트',
      category : '08',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/hobby/hobby_1.jpg',
      itemDesc : '심심할때 유투브 보면서 따라하기 쉬운 취미 툴 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-08-A2',
      itemNm   : '코바느질 DIY 세트',
      category : '08',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/hobby/hobby_2.jpg',
      itemDesc : '심심할때 유투브 보면서 따라하기 쉬운 취미 툴 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-08-A3',
      itemNm   : '코바느질 DIY 세트',
      category : '08',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/hobby/hobby_3.jpg',
      itemDesc : '심심할때 유투브 보면서 따라하기 쉬운 취미 툴 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-08-A4',
      itemNm   : '코바느질 DIY 세트',
      category : '08',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/hobby/hobby_4.jpg',
      itemDesc : '심심할때 유투브 보면서 따라하기 쉬운 취미 툴 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-08-A5',
      itemNm   : '코바느질 DIY 세트',
      category : '08',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/hobby/hobby_5.jpg',
      itemDesc : '심심할때 유투브 보면서 따라하기 쉬운 취미 툴 입니다.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
  //beauty
    {
      itemId : '20240312-03-A1',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_1.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-03-A2',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_2.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-03-A3',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_3.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-03-A4',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_4.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-03-A5',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_5.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },
    {
      itemId : '20240312-03-A6',
      itemNm   : '스위스 브랜드 립밤',
      category : '03',
      owner  : 'user02',
      buyHoper : [],
      liker    : [],
      openDate : new Date(),
      soldDate : null,
      itemImg : '/assets/img/beauty/beauty_6.jpg',
      itemDesc : '해외에서 10개씩 구입해왔는데 너무 많아서 올립니다. 무색 무향이에요.',
      status : '10',
      lastCd: '',
      visibleYn : true
    },


    
  ];

  export default item;